/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/button-has-type */
/* eslint-disable global-require */
import React from 'react';
import Head from 'next/head';
import Article from '../../Components/Article';
import DigitalDisplay from '../../Components/DigitalDisplay';
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';
import WantToLearnMore from '../../Components/WantToLearnMore';
import NavBarMobileProctoring from '../../Components/NavBarMobileProctoring';

import NavBarVerticalProctoring from '../../Components/NavBarVerticalProctoring';

class TestingEnvironment extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <Head>
          <title key="title">Edvice</title>
          <meta key="og:title" property="og:title" content="Edvice" />
          <meta key="description" name="description" content="Edvice" />
          <meta key="og:description" property="og:description" content="Edvice" />
        </Head>

        <Navbar>Navbar</Navbar>
        <div className="feature-exams">
          <DigitalDisplay
            color="red"
            image={require('./1.png')}
            column="col-xs-10 col-xs-offset-0 col-sm-5 col-sm-offset-2"
          >
            <Article>
              <header className="exams__header" id="exams">
                <h2>
                  <strong>Remote Proctored Linguaskill Tests</strong>
                </h2>
              </header>
            </Article>
          </DigitalDisplay>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <NavBarMobileProctoring />
              <NavBarVerticalProctoring />
            </div>
            <div className="col-sm-8 col-xs-12 col-md-8 col-lg-8">
              <div className="exam-format-content">
                <div className="section__one">
                  <h1>Testing Environment Set-up</h1>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture01.png')} />
                        <h4>Use a private testing area</h4>
                        <p>
                          Sit upright in an area where other people won’t talk and cannot pass
                          behind you.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture02.png')} />
                        <h4>Turn off all noise-making devices</h4>
                        <p>
                          Mobile phones set to vibrate emit detectable sound and any sound from a
                          mobile device is flagged as a violation.n’t talk and cannot pass behind
                          you.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture03.png')} />
                        <h4>Ensure your face is clearly visible</h4>
                        <p>
                          Hair, sunglasses, hats or anything that covers your face can cause test to
                          be flagged for low integrity. Eyeglasses are accepted.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture04.png')} />
                        <h4>Close irrelevant tabs and windows</h4>
                        <p>
                          The only tabs and windows open during the session should be those required
                          for the completion of the test. Screenshots will be taken of suspicious
                          activity and shown to your instructor.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture05.png')} />
                        <h4>Sit directly in front of your webcam</h4>
                        <p>
                          Make sure to stay in the middle of the webcam’s view. Leaving the frame or
                          looking away from the test will result in a low integrity grade.
                        </p>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <img alt="" src={require('./Picture06.png')} />
                        <h4>Create the proper lighting</h4>
                        <p>
                          Sit in a consistently well-lit room with as plain a background as
                          possible.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <WantToLearnMore />
        <Footer />
      </React.Fragment>
    );
  }
}
export default TestingEnvironment;
